import StyledFiltersBar from 'shared/components/styled/FiltersBar';
import SearchBar from './SearchBar';

const FiltersBar = () => (
  <StyledFiltersBar
    alignItems="center"
    direction="row"
    justifyContent="flex-end"
    spacing={2}
  >
    <SearchBar />
  </StyledFiltersBar>
);

export default FiltersBar;
